import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards';

const routes: Routes = [
  { 
    path: 'login', 
    loadChildren: () => import('./auth/login/login.module').then(m => m.LoginPageModule)
  },     
  {
    path: 'register',
    loadChildren: () => import('./auth/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'recuperar-password',
    loadChildren: () => import('./auth/recuperar-password/recuperar-password.module').then(m => m.RecuperarPasswordPageModule)
  },
  {
    path: 'perfil',
    canActivate: [AuthGuard],
    loadChildren: () => import('./auth/perfil/perfil.module').then(m => m.PerfilPageModule)
  },  
  { 
    path: 'acerca', 
    loadChildren: () => import('./pages/acerca/acerca.module').then(m => m.AcercaPageModule)
  },
  { 
    path: 'terminos-legales', 
    loadChildren: () => import('./pages/terminos-legales/terminos-legales.module').then(m => m.TerminosLegalesPageModule)
  },
  { 
    path: 'ayuda', 
    loadChildren: () => import('./pages/ayuda/ayuda.module').then(m => m.AyudaPageModule)
  },
  { 
    path: 'privacidad', 
    loadChildren: () => import('./pages/privacidad/privacidad.module').then(m => m.PrivacidadPageModule)
  },
  { 
  	path: '', 
  	loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      /*enableTracing: true,*/
      preloadingStrategy: PreloadAllModules 
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
